export enum MessageActionKindType {
  Primary = 'primary',
  Secondary = 'secondary',
  Undo = 'undo',
  Link = 'link',
}
